export default __webpack_public_path__ + "static/media/full-hd-low.b8ed702d.mp4";